import React from 'react';
import { ISignificanceControlStats } from '../../interfaces';
import * as SignificanceTableUI from './SignificanceTableUI';
import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../../utils/formatting';

interface IProps {
  control: ISignificanceControlStats;
}

const SignificanceChartControl = ({ control }: IProps) => {
  return (
    <>
      <SignificanceTableUI.VariantName>
        {control.variant}
      </SignificanceTableUI.VariantName>
      <div>
        <SignificanceTableUI.Label>Sample Size:</SignificanceTableUI.Label>
        {globalFormat.formatNumber(
          control.sampleSize,
          defaultNumberFormatOptions.originDecimalPoint,
        )}
      </div>
      <div>
        <SignificanceTableUI.Label>Mean:</SignificanceTableUI.Label>
        {globalFormat.formatNumber(
          control.mean,
          defaultNumberFormatOptions.originDecimalPoint,
        )}
      </div>
    </>
  );
};

export default SignificanceChartControl;
